import axiosInstance from "../../../services/axiosInstance";
import { STATUSES } from "./apiStatus";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


export const addCredit = createAsyncThunk(
  "addCredit/fetch",
  async (data, { rejectWithValue, serializeError, dispatch }) => {
    try {
      const response = await axiosInstance.post(`/EsignServices/AddCredit`, data);
      dispatch(setShowAlert(true)); // Dispatch the setShowAlert action
      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const addCreditSlice = createSlice({
  name: "addCredit",
  initialState: {
    creditData: {},
    creditStatus: "idle",
    error: null,
    showAlert: false, 
  },
  reducers: {
    updateCreditStatus: (state, action) => {
      state.creditStatus = action.payload;
    },
    setShowAlert: (state, action) => {
      state.showAlert = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCredit.pending, (state, action) => {
        state.creditStatus = STATUSES.LOADING;
      })
      .addCase(addCredit.fulfilled, (state, action) => {
        state.creditData = action.payload;
        state.creditStatus = STATUSES.IDLE;
      })
      .addCase(addCredit.rejected, (state, action) => {
        state.creditStatus = STATUSES.ERROR;
      });
  },
});

export default addCreditSlice.reducer;
export const { updateCreditStatus, setShowAlert } = addCreditSlice.actions;
